
































































































































































































































import {Component, Prop, Watch} from 'vue-property-decorator';
import Form, { Send } from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import DomainsApi from '@/services/rest/bemob/domains';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import WorkspaceSelect from '@/views/reports/pickers/wokrspace-select.vue';

import { mixins } from 'vue-class-component';
import ReportMixin from '@/views/reports/mixins/report-mixin';
import workspacesApi, {WorkspacesApi} from '@/views/settings/multi-user-access/workspaces/api';
import ApiServices from '@/services';
const md5 = require('md5');


@Component({
  components: {
    FormOverlay,
    DialogForm,
    ErrorAggregator,
    WorkspaceSelect,
  }
})

export default class AddCustomTrackingDomainDialog extends	mixins<Form, ReportMixin>(Form, ReportMixin) {
  @Prop({ default: {} })
  data: any;

  domainsApi: DomainsApi = new DomainsApi();

  workspacesApi: WorkspacesApi = workspacesApi;
  show: boolean = false;
  loading: boolean = false;
  loadingDns: boolean = false;
  step: number = 1;
  curentPlaceholder: string = 'go.yourdomain.com';

  targetDomain: any = '';
  domainCheckingSuccess: boolean = false;

  errors: any[] = [];
  errorsControlActive: boolean = false;

  form: any = {
    registar: 'namecheap',
    domain: '',
    workspaceIds: [],
  };

  registars: any [] = [
    { id: 'namecheap', name: this.t('Namecheap') },
    { id: 'godaddy', name: this.t('GoDaddy') },
    { id: 'cloudflare', name: this.t('Cloudflare') },
    { id: 'other', name: this.t('Other') },
  ];

  mounted() {
    this.workspacesApi.getWorkspaces()
    this.$on('error', this.onError);

    this.form.workspaceIds = [this.defaultWorkspace.id];

    this.form.domain = this.$store.state.cache.trackingDomains.data.filter(item=>!item.custom)[0].domain;

    this.show = true;
    this.oldHash = this.getCurrentHash()

  }

  beforeDestroy() {
    this.$off('error', this.onError);
  }

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify(this.form));
  }

  onError(e: any) {
    this.$store.commit('loading', false);
    this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
    this.errorsControlActive = true;
  }

  clearErrors() {
    this.errors = [];
    this.errorsControlActive = false;
    this.domainCheckingSuccess = false;
  }

  async nextStep() {
    if (this.step === 2 && !await this.checkDns('loading')) {
      return
    }
    this.step = this.step + 1;
  }

  successAddDomain() {
    this.close();
    this.bus.emit('toast-success', this.t('Domain has been successfully added'));
  }

  onChangeWorkspace(values: any = []) {
    this.clearErrors();
    this.loadAdditionalData(values).then(() => (this.form.workspaceIds = values));
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash()) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  close() {
    this.$emit('close');
  }

  @Watch('step') 
  onStepChanged() {
    this.clearErrors();
  }

  @Send()
  checkDns(loading): Promise<any> {
    this.clearErrors();
    this[loading] = true;
    return this.domainsApi.postCheckTrackingDomainDns({domain: this.targetDomain})
      .then((data: any) => {
        if (data.status ===  'FAIL') {
          this.errors = [this.t(data.error,[data.values.domain,data.values.setTo,data.values.shouldBe])]
          this.errorsControlActive = true;
          return;
        }
        this.domainCheckingSuccess = true;
        return true
      }).finally(()=>{
        this[loading] = false;
      });
  }

  @Send()
  createDomain(){
    this.loading = true;
    this.clearErrors();
    const { workspaceIds } = this.form

    if (!workspaceIds.length) {
      this.errors.push(this.t('{0} is required',[this.t('Assigned Workspace')]))
      this.errorsControlActive = true;
      this.loading = false;
      return
    }

    const mapWorkscpaces = this.workspacesApi.data.reduce((acc, item) => {
      acc[item.id] = item
      return acc
    }, {})

    return this.domainsApi.createTrackingDomain({ domain: this.targetDomain })
      .then(({ id: domainId }: any) => {
        const promises = workspaceIds.map((id: string) => {
          const { name, trackingDomainIds } = mapWorkscpaces[id]
          return this.workspacesApi.putWithoutUserUpdate({
            id,
            name,
            trackingDomainIds: [...trackingDomainIds, domainId],
          })
        })
        Promise.all(promises)
          .then(async () => {
            this.successAddDomain()
            await ApiServices.getUserProfile();
          })
          .finally(() => {
            this.close();
          });
      }).finally(() => {
        this.loading = false;
      });
  }
}
